const footerSkin = {
  footer: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
    padding: "16px 5px",
    "@media (max-width: 768px)": {
      "flex-direction": "column",
    },
  },
  "footer-bottom-border": {
    "border-color": "var(--gc-border-separator-color)",
    "border-width": "1px",
    "border-style": "none none solid none",
    width: "100%",
    height: "1px",
  },
  "footer-error": {
    display: "flex",
    "flex-direction": "column",
    padding: "16px 5px",
    "border-color": "var(--gc-border-separator-color)",
    "border-width": "1px",
    "border-style": "none none solid none",
  },
  "footer-child": {
    display: "flex",
    "& > div": {
      display: "flex",
      "flex-direction": "row",
      "align-items": "center",
      padding: "5px",
      "justify-content": "end",
    },
    "& > div > div": {
      paddingRight: "5px",
    },
  },
  "footer-child-mobile": {
    "flex-direction": "column",
  },
  pagination: {
    composes: "pagination",
    ".pagination&": {
      margin: "0",
      "list-style": "none",
    },
  },
  "page-link": {
    composes: "page-link",
    ".page-link&": {
      cursor: "pointer",
    },
  },
  "page-number": {
    composes: "form-control",
    "&.form-control": {
      borderRadius: "0",
      width: "100px",
      borderLeft: "none",
      borderRight: "none",
    },
  },
  "per-page-dropdown": {
    composes: "form-control form-select",
    "min-width": "70px",
  },
};

export default footerSkin;
